import { IUserInfo } from 'types/user'
export type IUser = IUserInfo

export type T$store = {
    user: IUser
    deviceId: string
    cookie: string
    mainSpaceId: string
    helpPageTab: string
    debug: boolean
}

export const $store: T$store = new Proxy({
    user: {
        userid: '827350621',
        nickname: '176****6171',
        access_token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjQxMmZjNWEyLTQzMmMtNDE5My1hZjdiLTA5M2M3ZDFkZWNiZiJ9.eyJpc3MiOiJodHRwczovL3hsdXNlci1zc2wueHVubGVpLmNvbSIsInN1YiI6IjgyNzM1MDYyMSIsImF1ZCI6Ill2Umg4eHVoMXFUTWV3SHYiLCJleHAiOjE2OTMzNjg4NDMsImlhdCI6MTY5MzM2MTY0MywiYXRfaGFzaCI6InIuckxETEpUZDRRUHl3QnJETmtNY2hIUSIsInNjb3BlIjoicHJvZmlsZSBwYW4gc3NvIHVzZXIiLCJwcm9qZWN0X2lkIjoiMnJ2azRlM2drZG5sN3Uxa2wwayJ9.jsZ1YJzR_p5bYf_kPR4GdM-r-uW0Ixg6AEC-_jTbw9lCI4OeZmczZf2TNx4f7ak4heHMLgfy7JLLWcMYyQBin-3jCaKbOc0Ne2psnxNPZCR2zz5pK3dIM6aqciaDhVMbL561qpnVZdUlebTdDzoupk6Q6HEhbaj8DK4GuTZGYHOJ8uQbGl2KnFfOex6ezrQqnErhx_obmTmm9KdLWwqIA7n5NmCRjCtQwr7HGwIUIyiXsdJ6ruVmFIJiFJzzAv4BjjEZeV-tVW4l4h69n0hHjXPxo7Yq0OpImc5k-npwLFjbtrN_QqQDZ0aT9VZI4ghGO3WgFG519QxoqWnofQK5eQ',
        expireDate: ''
    },
    deviceId: '47e31b52448f5d065c3e914f9453652f',
    cookie: '',
    mainSpaceId: '',
    helpPageTab: 'loginAndBind',
    debug: process.env.NODE_ENV === 'development'
}, {
    get: function (target, propKey, receiver) {
        return Reflect.get(target, propKey, receiver)
    },
    set: function (target, propKey, value, receiver) {
        return Reflect.set(target, propKey, value, receiver)
    }
})
